/**
 * Helpers para permissão de FileSystemDirectoryHandle.
 *
 * Chrome/Edge revogam a permissão `readwrite` após algum tempo sem uso ou
 * após reload. Antes de cada execução o agendador deve verificar o estado
 * da permissão e, se necessário, re-solicitar com gesture do usuário.
 *
 * IMPORTANTE: `requestPermission` SEM gesture é bloqueado pelo navegador.
 * Use o helper `precisaGesturePraPermissao` para detectar essa situação
 * e mostrar o badge no Header (clique = gesture).
 */

const READWRITE = { mode: "readwrite" };

export function suporteFileSystemAccess() {
  return (
    typeof window !== "undefined" &&
    typeof window.showDirectoryPicker === "function"
  );
}

export async function statusPermissao(handle) {
  if (!handle || typeof handle.queryPermission !== "function") return "indisponivel";
  try {
    return await handle.queryPermission(READWRITE);
  } catch {
    return "indisponivel";
  }
}

/**
 * Tenta obter permissão `readwrite`. Só chame DENTRO de um handler de
 * evento (clique, etc.) — caso contrário o navegador bloqueia silenciosamente.
 *
 * @returns {Promise<"granted"|"denied"|"indisponivel">}
 */
export async function solicitarPermissao(handle) {
  if (!handle || typeof handle.requestPermission !== "function") return "indisponivel";
  try {
    return await handle.requestPermission(READWRITE);
  } catch {
    return "indisponivel";
  }
}

export function precisaGesturePraPermissao(status) {
  // status "prompt" significa que a API precisa ser chamada com gesture.
  return status === "prompt";
}
